import styled from "styled-components";
import { colors } from "../../common/element/mondiya/elements.js";

export const Styles = styled.div`
    /* Course Details */
    .course-details-area {
        background: ${colors.bg2};
        padding: 70px 0 78px;

        .course-details-top {
            .heading {
                h4 {
                    color: ${colors.black1};
                    font-weight: 600;
                    line-height: 35px;
                    margin-bottom: 25px;

                    @media(max-width: 575px) {
                        font-size: 20px;
                    }
                }

                p.how-para {
                    font-size: 15px;
                    color: ${colors.text3};
                    line-height: 28px;
                    text-align: left;

                    @media(max-width: 991px) {
                        font-size: 14px;
                    }
                }
            }

            .course-tab-list {
                .nav {
                    display: inline-block;
                    border-radius: 5px;
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                    margin-bottom: 35px;

                    .nav-item {
                        display: inline-block;

                        a.nav-link {
                            font-size: 14px;
                            color: ${colors.black2};
                            font-weight: 500;
                            text-transform: uppercase;
                            padding: 12px 30px 10px;
                            border-radius: 5px;

                            @media(max-width: 991px) {
                                padding: 12px 16px 9px;
                            }
                        }

                        a.nav-link.active {
                            background: ${colors.gr_bg};
                            color: #ffffff;
                        }
                    }
                }

                .tab-content {
                    .instructor-tab {
                        h5 {
                            color: ${colors.black2};
                            font-weight: 600;
                            padding-bottom: 10px;
                            margin-bottom: 35px;
                            position: relative;

                            &:before {
                                position: absolute;
                                content: "";
                                background: ${colors.green};
                                width: 50px;
                                height: 2px;
                                bottom: 0;
                                left: 0;
                            }

                            @media(max-width: 575px) {
                                font-size: 17px;
                            }
                        }

                        .instructor-item {
                            margin-bottom: 30px;

                            .instructor-img img {
                                border-radius: 5px;
                                width: 100%;
                                height: auto;
                            }

                            .instructor-content {
                                .instructor-box {
                                    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
                                    padding: 25px;
                                    background: #ffffff;
                                    border-radius: 5px;
                                    position: relative;
                                    margin-top: 20px;

                                    .top-content {
                                        margin-bottom: 20px;

                                        .instructor-name h6 {
                                            color: ${colors.black2};
                                            font-weight: 600;
                                            text-transform: uppercase;
                                            margin-bottom: 12px;

                                            @media(max-width: 575px) {
                                                font-size: 14px;
                                            }
                                        }

                                        p {
                                            font-size: 14px;
                                            color: ${colors.text3};
                                            font-weight: 500;
                                        }
                                    }

                                    .instructor-desk p {
                                        font-size: 15px;
                                        color: ${colors.text2};
                                        line-height: 25px;
                                        padding-bottom: 10px;

                                        @media(max-width: 575px) {
                                            font-size: 14px;
                                        }

                                        span {
                                            font-weight: bold;
                                            
                                            a{
                                                font-size: 15px;
                                                color: ${colors.blue};
                                            }

                                            a:hover{
                                                font-size: 15px;
                                                color: ${colors.blue};
                                                text-decoration: underline;
                                            }
                                        }
                                    }
                                }
                            }

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }
        }

        .single-details-sidbar {
            .course-details-feature {
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                padding: 15px 20px 20px;

                h5.title {
                    color: ${colors.black1};
                    font-weight: 600;
                    padding-bottom: 10px;
                    margin-bottom: 20px;
                    position: relative;

                    &:before {
                        position: absolute;
                        content: "";
                        background: ${colors.green};
                        width: 50px;
                        height: 2px;
                        bottom: 0;
                        left: 0;
                    }

                    @media(max-width: 575px) {
                        font-size: 17px;
                    }
                }

                ul.feature-list {
                    margin-bottom: 20px;

                    li {
                        border-top: 1px dashed ${colors.border3};
                        padding: 12px 0;
                        font-size: 14px;
                        color: ${colors.black2};
                        font-weight: 500;

                        i {
                            font-size: 20px;
                            color: ${colors.green};
                            vertical-align: top;
                            margin-right: 2px;
                        }

                        span {
                            float: right;
                            font-size: 13px;
                            color: ${colors.text3};
                            font-weight: 400;
                            line-height: 20px;
                        }

                        &:first-child {
                            border-top: none;
                            padding-top: 0;
                        }

                        &:last-child {
                            padding-bottom: 0;
                        }
                    }
                }

                button.enroll-btn {
                    font-size: 16px;
                    color: #fff;
                    background: ${colors.gr_bg};
                    display: inline-block;
                    width: 100%;
                    height: 40px;
                    font-weight: 500;
                    border: none;
                    padding: 9px;
                    border-radius: 5px;

                    &:hover {
                        background: ${colors.gr_bg2};
                    }

                    @media(max-width: 575px) {
                        font-size: 14px;
                    }
                }

                @media(max-width: 1199px) {
                    padding: 12px 15px 15px;
                }
            }
        }

        @media(max-width: 767px) {
            padding: 20px 0 5px;
        }
    }

    /* Mobile and smaller devices adjustments */
    @media(max-width: 576px) {
        .course-details-area {
            padding: 30px 0;
        }

        .course-tab-list {
            .nav {
                display: block;

                .nav-item {
                    margin-bottom: 10px;
                }
            }
        }

        .instructor-item {
            .instructor-content {
                .instructor-box {
                    padding: 20px;
                }
            }
        }
    }
`;